export default {
  domain_name: process.env.REACT_APP_DOMAIN_NAME
};
